import { Grid, Text } from '@vtex/shoreline'

import type { InsertionOrderMetricItem } from './hooks/useCampaignInsertionOrderPanelData'

import styles from './styles.module.css'

type MetricsProps = {
  metrics?: InsertionOrderMetricItem[] | null
}

export const CampaignInsertionOrderMetrics = ({ metrics }: MetricsProps) => {
  const items = metrics ?? []
  if (items.length === 0) return null

  const columns = Math.min(items.length, 4)

  return (
    <Grid
      className={styles.metrics}
      columns={`repeat(${columns}, minmax(0, 1fr))`}
      gap="$space-4"
      data-testid="campaign-io-metrics"
      data-columns={columns}
    >
      {items.map(metric => (
        <div
          key={metric.key}
          className={styles.metric}
          data-testid={`campaign-io-metric-${metric.key}`}
        >
          <Text as="div" variant="caption1" color="var(--sl-fg-base-soft)">
            {metric.label}
          </Text>
          <Text as="div" variant="emphasis">
            {metric.value ?? '—'}
          </Text>
        </div>
      ))}
    </Grid>
  )
}
